import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import DiscreteTabs from 'components/DesignSystem/Tabs/DiscreteTabs';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/meteorologyFieldsLayoutReducer';
import useIsMobile from 'utils/hooks/useIsMobile';
import usePentadRoundsSync from 'hooks/Meteorology/Fields/ModelPerformance/usePentadRoundsSync';

export default function ModelPerformance() {
  const isMobile = useIsMobile();
  usePentadRoundsSync();

  useEffect(() => {
    store.dispatch(setCurrentTab('modelperformance'));
  }, []);

  return (
    <div>
      {!isMobile && (
        <DiscreteTabs type="underline" activeKey="./">
          <DiscreteTabs.Tab
            path="/meteorology/fields/modelperformance/overview"
            title="Visão Geral"
          />
          {/* Visão Detalhada oculta até implementação futura
          <DiscreteTabs.Tab
            path="/meteorology/fields/modelperformance/detailedview"
            title="Visão Detalhada"
          />
          */}
        </DiscreteTabs>
      )}
      <div>
        <Outlet />
      </div>
    </div>
  );
}
